import { render } from "./ModalFormPrecios.vue?vue&type=template&id=b2b6c82e&scoped=true"
import script from "./ModalFormPrecios.vue?vue&type=script&lang=js"
export * from "./ModalFormPrecios.vue?vue&type=script&lang=js"

import "./ModalFormPrecios.vue?vue&type=style&index=0&id=b2b6c82e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b6c82e"]])

export default __exports__